var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746513618158,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 29838,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M592 256l96-192c-24.4-13.968-76.064-0.288-96-16C536.096 3.904 487.52 7.6 432 48c-22.608 16.448-69.52-0.272-96 16l96 192",
    fill: "#ffffff",
    "p-id": 29839
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M688 64l-64-16-96 208h48l112-192z",
    fill: "#ffffff",
    "p-id": 29840
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 256c220.768 0 400 258.096 400 576 0 30.464 114.352 69.696 88 144-20.56 57.984-104.32 16-104.32 16C634.48 1010.864 373.264 1011.28 112 992c0 0-74.112 33.552-90.288-16C4 921.68 112 856.64 112 832c0-317.904 179.232-576 400-576z",
    fill: "#ffffff",
    "p-id": 29841
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.712 976c18.592-123.2 564.144 39.536 715.92-97.888 160.304-145.152-6.24-529.936 0-521.68C830.128 478.96 912 634.592 912 832c0 30.464 114.352 69.696 88 144-20.56 57.984-104.32 16-104.32 16C634.48 1010.864 373.264 1011.28 112 992c0 0-98.176 36.352-90.288-16z",
    fill: "#ffffff",
    "p-id": 29842
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M464 640a48.432 48 90 1 0 96 0 48.432 48 90 1 0-96 0Z",
    fill: "#ffffff",
    "p-id": 29843
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagging);
export default __webpack_public_path__ + "static/media/bagging.393d57cc4630885971e850fed9127c4e.svg";
export { ForwardRef as ReactComponent };